import fetchData from '../../api/fetchData';
import { safeCall } from './errors';

const apiPersonsUrl = `${process.env.API_HOST_URL}${process.env.API_PERSONS}`;

export function* fetchMailBoxes() {
  return yield safeCall(fetchData, `${apiPersonsUrl}/mail_boxes`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
}
